@if (this.requestState.isLoading()) {
  <div class="footer-loading"></div>
}

@if (this.entries().length > 0) {
  <div class="footer-container">
    @for (entry of this.entries(); track entry.key) {
      <div class="footer-entry">
        <span class="footer-entry__key">{{ 'grid.footer.' + entry.key | translate }}</span>
        <span class="footer-entry__value">{{ entry.value | currency }}</span>
      </div>
    }
  </div>
}
